import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { CollectionPaths } from '@models/collections';
import { MatterTitle } from '@models/matter';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Repo } from '@repos/repo.service';
import { UserProfileState } from '@state/user-profile';

export interface MatterTitlesPathParams {
	matterId: string;
}

@Injectable({
	providedIn: 'root',
})
export class MatterTitlesRepoService extends Repo<
	MatterTitle,
	MatterTitlesPathParams
> {
	@SelectSnapshot(UserProfileState.getCurrentBusinessId) businessId;

	constructor(private firestore: AngularFirestore) {
		super(firestore);
	}

	GetCollectionPath(pathParams: MatterTitlesPathParams): string {
		return CollectionPaths.business_matter_titles(
			this.businessId,
			pathParams.matterId,
		);
	}
}
